import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { typography } from "../../utils/typography";
import { semanticColors } from "../../utils/colors";

export default function NotFound() {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "70vh",
        gap: 1.5,
        textAlign: "center",
        px: 3
      }}
    >
      <Typography
        sx={{
          fontFamily: "'Inter', sans-serif",
          fontSize: 72,
          fontWeight: 700,
          lineHeight: 1,
          color: semanticColors.action.primary
        }}
      >
        404
      </Typography>
      <Typography
        sx={{ ...typography.body.l, color: semanticColors.text.secondary }}
      >
        {t("common.notFound")}
      </Typography>
    </Box>
  );
}
